var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartActive = function SvgHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "#102262"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "m10.815 19.83-.016-.015-.016-.014c-3.131-2.76-5.665-5.024-7.423-7.154C1.61 10.526.7 8.617.7 6.577.7 3.258 3.265.7 6.6.7c1.832 0 3.678.864 4.867 2.264l.534.629.533-.63C13.72 1.564 15.568.7 17.401.7c3.335 0 5.9 2.559 5.9 5.876 0 1.794-.703 3.483-2.059 5.305-1.364 1.832-3.35 3.747-5.845 5.986l-.001.002-2.18 1.933-.015.014-.014.014L12 21.012l-1.185-1.182Z"
  })));
};
export default SvgHeartActive;